<template>
  <div>
    <DialogBase
      v-model="inputValue"
      :title="$t('nextengine.nextengine_ec-goods-management')"
      :isFooter="true"
      :width="width"
      isCardColor="true"
    >
      <template #title="{ dialogTitle }">
        <span class="pl-5 py-2 dialogTitleStyle">
          {{ dialogTitle }}
        </span>
      </template>
      <div class="productInfo">
        <v-expansion-panels accordion multiple v-model="openPanelIndex">
          <v-data-table
            :items="pageProductList"
            :headers="headers"
            item-key="supplierId"
            group-by="supplierId"
            class="elevation-1 width100"
            :items-per-page="-1"
            :no-data-text="$t('common.common_not-register')"
            show-group-by
            hide-default-header
            hide-default-footer
          >
            <template v-slot:group="props">
              <v-expansion-panel>
                <v-expansion-panel-header disable-icon-rotate>
                  <template v-slot:actions>
                    <DisplaySwitchButton :open="isOpenPanelOpen(props.group)" />
                  </template>
                  <span class="header">
                    {{ props.items[0].supplierName }}
                  </span>
                </v-expansion-panel-header>
                <v-divider></v-divider>
                <v-expansion-panel-content>
                  <ProductTable
                    :headers="headers"
                    :items="props.items"
                    :ecGoodsData="ecGoodsData"
                    item-key="productId"
                    class="productTable"
                    @edit="edit"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </template>
          </v-data-table>
        </v-expansion-panels>
      </div>
    </DialogBase>
  </div>
</template>
<script>
import DialogBase from '@/components/layouts/Dialogs/DialogBase'
import _cloneDeep from 'lodash/cloneDeep'
import { mapGetters, mapActions } from 'vuex'

import headers from './headers'
import { DisplaySwitchButton } from '@/components/items'

import ProductTable from './ProductTable'

export default {
  components: {
    DialogBase,
    DisplaySwitchButton,
    ProductTable
  },
  props: {
    value: { default: false },
    width: { default: '1166px' },
    //linkedProductId: { default: null },
    ecGoodsData: {
      type: Object,
      default: () => ({}) // 初期値を空オブジェクトに設定
    },
    editMode: {
      type: Boolean,
      require: false,
      default: false
    },
    selectCurrency: {
      type: Object,
      require: true
    }
  },
  data: () => ({
    openPanelIndex: [],
    groupNames: [],
    pageProductList: [],
    headers: headers.headers,

    productList: [],
    productListData: [],
    editProductData: {},

    //linkedProductId: null,
    //ecGoodsId: null,

    errDialog: false
  }),
  async created() {
    await this.init()
  },
  methods: {
    ...mapActions('Product', ['getProductListFromApi']),
    ...mapGetters('Product', ['getProductListFromState']),

    ...mapActions('Supplier', ['getSuppliersFromApi']),
    ...mapGetters('Supplier', ['getSuppliersFromState']),

    async init() {
      await this.createProductListData()
      this.setGroupNames()
    },
    getSupplierName(id) {
      const supplier = this.getSuppliersFromState().find(
        (ele) => ele.supplierId === id
      )
      return supplier ? supplier.name : this.$t('common.common_unknown')
    },

    getSupplierIsEnabled(id) {
      const supplier = this.getSuppliersFromState().find(
        (ele) => ele.supplierId === id
      )
      return supplier.isEnabled
    },

    async createProductListData() {
      const supplierId = null
      await this.getProductListFromApi()
      const productList = this.getProductListFromState()

      this.productList = productList

      await this.getSuppliersFromApi()
      this.pageProductList = productList.map((ele) => {
        ele.supplierName = this.getSupplierName(ele.supplierId)
        // ソート用の値を追加
        // 商品名
        ele.productInfo = ele.nameJp + ele.nameCn
        return ele
      })
      this.productListData = productList.map((ele) => {
        return {
          ...ele,
          productId: ele.productId,
          invalid: false,
          supplierId: ele.supplierId
        }
      })
    },

    isName(header, name) {
      return header.value === name
    },

    setGroupNames() {
      const productListTmp = [...this.productList]

      this.groupNames = productListTmp
        .sort((a, b) => {
          if (a.supplierId < b.supplierId) return -1
          if (a.supplierId > b.supplierId) return 1
          return 0
        })
        .reduce((result, current) => {
          var element = result.find((p) => p.groupId === current.supplierId)
          if (!element) {
            result.push({
              groupId: current.supplierId,
              open: false,
              index: result.length
            })
          }
          return result
        }, [])
    },
    isOpenPanelOpen(id) {
      //console.log(this.ecGoodsData)
      const group = this.groupNames.find((p) => p.groupId === id)
      return group ? group.open : false
    },

    setGroupNamesOpen(newVal) {
      this.groupNames = this.groupNames.map((data, index) => {
        data.open = newVal.find((val) => val === data.index) !== undefined
        return data
      })
    },
    edit(editProductData) {
      this.$emit('edit', editProductData)
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  watch: {
    inputValue: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal) this.init()
      }
    },
    ecGoodsData: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal) this.init()
      }
    },
    openPanelIndex: function (val) {
      this.setGroupNamesOpen(val)
    }
  }
}
</script>
<style scoped lang="scss">
.dialogTitleStyle {
  font-size: 22px;
}
.productInfo {
  .icon {
    order: 0;
  }
  .header {
    order: 1;
  }
  .width100 {
    width: 100%;
  }
}
</style>
